import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TenMetreWalkTestTableComponent from './TenMetreWalkTestTableComponent';

const TenMetreWalk: React.FC = () => {
  const { t } = useTranslation('tests');
  return (
    <Grid container spacing={2} sx={{ mt: 1, alignItems: 'stretch',  flexDirection: 'column' }}>
      <Grid size={8}>
        <Typography>{t('subPages.tenMetreIntro')}</Typography>
      </Grid>
      <Grid sx={{ mr: 4 }}>
        <TenMetreWalkTestTableComponent />
      </Grid>
    </Grid>
  );
};

export default TenMetreWalk;
